/** Canvas helpers. All ops avoid CSS scaling so output stays at native res. */

export async function imageBlobToBitmap(blob: Blob): Promise<ImageBitmap> {
  return await createImageBitmap(blob, { imageOrientation: 'from-image' });
}

export function bitmapToCanvas(bmp: ImageBitmap): HTMLCanvasElement {
  const c = document.createElement('canvas');
  c.width = bmp.width; c.height = bmp.height;
  const ctx = c.getContext('2d', { willReadFrequently: false })!;
  ctx.drawImage(bmp, 0, 0);
  return c;
}

export async function canvasToBlob(c: HTMLCanvasElement, type = 'image/png', q = 0.95): Promise<Blob> {
  return await new Promise((res, rej) => c.toBlob(b => b ? res(b) : rej(new Error('toBlob null')), type, q));
}

export async function loadImage(src: string): Promise<HTMLImageElement> {
  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.decoding = 'async';
  img.src = src;
  await img.decode();
  return img;
}

export async function blobToDataURL(b: Blob): Promise<string> {
  return await new Promise((res, rej) => {
    const fr = new FileReader();
    fr.onload = () => res(String(fr.result));
    fr.onerror = () => rej(fr.error);
    fr.readAsDataURL(b);
  });
}

export interface ResizeOpts { maxLong?: number; minLong?: number; keepAspect?: boolean; }

export function fitTarget(w: number, h: number, opts: ResizeOpts): { w: number; h: number } {
  const long = Math.max(w, h);
  const min = opts.minLong ?? 0;
  const max = opts.maxLong ?? Infinity;
  const target = Math.min(Math.max(long, min), max);
  const s = target / long;
  return { w: Math.round(w * s), h: Math.round(h * s) };
}
